// extracted by mini-css-extract-plugin
export default {"BankStatementInfo":"BankStatementUploadWarning_BankStatementInfo__-rUq9"};